import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
var __jsx = React.createElement;
//@ts-ignore

import stl from "./CarCompare.module.css";
import React, { createContext, useContext, useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "@i18n";
import useHelpers from "@hooks/useHelpers";
import useIsMobile from "@hooks/useIsMobile";
import { trackEvents } from "@/common/events/events";
import { useSession } from "@/_MiniApps/auth/AuthContext";
// import { FEATURFLAG_PROBABILITY } from "@globalConfig";
import { twMerge } from "tailwind-merge";
import { AuthPopupHOC } from "@/_MiniApps/auth/AuthContext";
import { handleHasAccountEvent } from "@/utils/common";
import { useLang } from "@/common/Contexts/LanguageContext";
import banners from "@data/banners/login-pages/car_report.json";
import { useCMS } from "@hooks/useCMS";
import useLocalStorage from "@hooks/useLocalStorage";
var LOCAL_STORAGE_KEY = "car_compare_data";
var CarCompare = /*#__PURE__*/createContext(undefined);
var CarCompareProvider = function CarCompareProvider(_ref) {
  var children = _ref.children;
  // Dynamically generate a random number and check if it falls within the desired range
  // const generateProbability = () => {
  //   const probability = parseFloat(FEATURFLAG_PROBABILITY); // Get probability from the environment
  //   if (Math.random() < probability) {
  //     return probability; // Use the calculated probability
  //   }
  //   return 0; // Default to 0 if it doesn't fall within the range
  // };

  // const isCarCompareEnabled = useFeatureToggle(
  //   generateProbability(),
  //   "car-compare-feature"
  // );

  var _useTranslation = useTranslation(["web_common"]),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl,
    navigateTo = _useHelpers.navigateTo;
  var location = useLocation();
  var _useSession = useSession(),
    isLoggedIn = _useSession.isLoggedIn,
    user = _useSession.user;
  var isMobile = useIsMobile();
  var _useState = useState({
      cars: [],
      maxCars: 2,
      referral_location: ""
    }),
    bigData = _useState[0],
    setBigData = _useState[1];
  var isDesktop = !isMobile;
  var lang = useLang();
  var _useLocalStorage = useLocalStorage(),
    getLocalStorage = _useLocalStorage.getLocalStorage,
    setLocalStorage = _useLocalStorage.setLocalStorage;
  var _useCMS = useCMS(),
    imageUrl = _useCMS.imageUrl;
  var authScreenDesign = {
    banners: {
      desktop: imageUrl(banners[lang].desktop_images[0]),
      mobile: imageUrl(banners[lang].mobile_images[0])
    },
    title: t("ابدأ مقارنة السيارات الآن!", {
      ns: "web_common"
    }),
    description: t("سجل الدخول أو قم بإنشاء حساب الآن لتتمكن من الإطلاع على جدول المقارنة.", {
      ns: "web_common"
    })
  };
  var isAddCarAllowed = function isAddCarAllowed() {
    var allowedUrls = ["/filters", "/autos", "/user/favorite", "/deal", "/en/filters", "/en/autos", "/en/user/favorite", "/en/deal"];
    return allowedUrls.some(function (url) {
      return location.pathname.startsWith(url);
    });
  };
  var isCompareBarAllowed = function isCompareBarAllowed() {
    var allowedUrls = ["/filters", "/autos", "/user/favorite", "/deal", "/en/filters", "/en/autos", "/en/user/favorite", "/en/deal"];
    return allowedUrls.some(function (url) {
      return location.pathname.startsWith(url);
    });
  };
  useEffect(function () {
    var storedData = getLocalStorage(LOCAL_STORAGE_KEY);
    if (storedData) {
      try {
        var parsedData = JSON.parse(storedData);
        setBigData(parsedData);
      } catch (error) {
        console.error("Failed to parse localStorage data", error);
      }
    }
  }, []);
  useEffect(function () {
    setLocalStorage(LOCAL_STORAGE_KEY, JSON.stringify(bigData));
  }, [bigData]);
  var hasCarsToCompare = function hasCarsToCompare() {
    return bigData.cars.length > 0;
  };
  var canStartComparison = function canStartComparison() {
    return bigData.cars.length > 1;
  };
  var isCarIncluded = function isCarIncluded(carId) {
    return bigData.cars.some(function (car) {
      return parseInt(car.id, 10) === parseInt(carId, 10);
    });
  };
  var canAddMoreCars = function canAddMoreCars() {
    return bigData.cars.length < bigData.maxCars;
  };
  var addCar = function addCar(car) {
    if (canAddMoreCars() && !isCarIncluded(parseInt(car.id, 10))) {
      trackEvents("compare_car_select", {
        user_id: isLoggedIn ? "9665" + user.phone_number : "null",
        post_id: car.id,
        referral_location: getlocationNameFromPathName(location.pathname),
        post_make: car.g4_data_layer.post_make,
        post_model: car.g4_data_layer.post_model,
        post_year: car.g4_data_layer.post_year
      });
      updateData("cars", [].concat(_toConsumableArray(bigData.cars), [car]));
      return true;
    }
    return false;
  };
  var removeCar = function removeCar(carId) {
    updateData("cars", bigData.cars.filter(function (car) {
      return parseInt(car.id, 10) !== carId;
    }));
  };
  var resetAllCars = function resetAllCars() {
    updateData("cars", []);
  };
  var renderSnackBarBar = function renderSnackBarBar() {
    if (bigData.maxCars == bigData.cars.length) return null;
    if (isMobile) return /*#__PURE__*/React.createElement("div", {
      className: "fixed bottom-10 left-[5%] w-[90%] flex items-center p-3 px-4 gap-1 rounded-lg bg-[#3C56D4] text-white text-sm font-bold leading-6"
    }, /*#__PURE__*/React.createElement("span", {
      className: stl.ResetCompare,
      onClick: resetAllCars
    }), /*#__PURE__*/React.createElement("span", null, t("اختر سيارة أخرى لبدء المقارنة", {
      ns: "web_sell_trade"
    })));
    return /*#__PURE__*/React.createElement("div", {
      className: "m-0 mx-auto flex items-center p-3 px-4 gap-1 rounded-lg bg-[#3C56D4] text-white text-sm font-bold leading-6 max-w-[1330px] mt-1"
    }, /*#__PURE__*/React.createElement("span", {
      className: stl.ResetCompare,
      onClick: resetAllCars
    }), /*#__PURE__*/React.createElement("span", null, t("اختر سيارة أخرى لبدء المقارنة", {
      ns: "web_sell_trade"
    })));
  };
  var getlocationNameFromPathName = function getlocationNameFromPathName(pathname) {
    if (pathname.indexOf("/autos") > -1) return "autos";
    if (pathname.indexOf("/user/favorite") > -1) return "favorite";
    var locationName = pathname.split("/").filter(function (item) {
      return item !== "";
    });
    return locationName[0];
  };
  var triggerStartComparisonEvent = function triggerStartComparisonEvent(checkAuth) {
    checkAuth(function (userData, isPendingActionCall) {
      isPendingActionCall && handleHasAccountEvent({
        hasAccount: userData.has_account,
        status: "Success",
        phone_number: userData === null || userData === void 0 ? void 0 : userData.phone_number,
        lang: "ar",
        referral_location: "inspection_report"
      });
      trackEvents("comparison_start", {
        user_id: isLoggedIn ? "9665" + user.phone_number : "null",
        referral_location: getlocationNameFromPathName(location.pathname),
        post_1_id: bigData.cars[0].id,
        post_1_make: bigData.cars[0].g4_data_layer.post_make,
        post_1_model: bigData.cars[0].g4_data_layer.post_model,
        post_1_year: bigData.cars[0].g4_data_layer.post_year,
        post_1_condition: bigData.cars[0].g4_data_layer.post_condition,
        post_2_id: bigData.cars[1].id,
        post_2_make: bigData.cars[1].g4_data_layer.post_make,
        post_2_model: bigData.cars[1].g4_data_layer.post_model,
        post_2_year: bigData.cars[1].g4_data_layer.post_year,
        post_2_condition: bigData.cars[1].g4_data_layer.post_condition
      });
      updateData("referral_location", location.pathname + location.search);
      var queryParams = "compare_cars=".concat(bigData.cars.map(function (car) {
        return car.id;
      }).join(","));
      navigateTo(createUrl("/site/car-compare?".concat(queryParams)));
    });
  };
  var renderStartCompare = function renderStartCompare(checkAuth) {
    // if (!canStartComparison() || !isCarCompareEnabled) return null;
    if (!canStartComparison()) return null;
    if (isMobile) return /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between items-center rounded-lg bg-[#00B362] fixed bottom-10 left-[5%] w-[90%] py-3 px-4"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between items-center gap-[5px]"
    }, /*#__PURE__*/React.createElement("span", {
      className: stl.ResetCompare,
      onClick: resetAllCars
    }), /*#__PURE__*/React.createElement("span", {
      className: "text-white text-sm font-bold leading-6"
    }, t("رائع!", {
      ns: "web_sell_trade"
    }))), /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        return triggerStartComparisonEvent(checkAuth);
      }
      // href={createUrl(`/site/car-compare?${queryParams}`)}
      ,
      className: "flex w-[96px] min-h-[32px] items-center justify-center text-[#00B362] text-xs font-bold leading-4 bg-[#FFFFFF] rounded-lg border-0"
    }, t("ابدأ المقارنة", {
      ns: "web_sell_trade"
    })));
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        return triggerStartComparisonEvent(checkAuth);
      }
      // href={createUrl(`/site/car-compare?${queryParams}`)}
      ,
      className: "flex items-center justify-center rounded bg-[#00B362] p-1 px-2 h-8 max-w-[228px] m-0 mx-auto mt-4 lg:-mb-[20px] border-0"
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-white text-xs font-bold leading-4"
    }, t("ابدأ المقارنة", {
      ns: "web_sell_trade"
    }))));
  };
  var renderCarBox = function renderCarBox() {
    // if (!isCarCompareEnabled) return null;
    return /*#__PURE__*/React.createElement("div", {
      className: "flex gap-2 md:gap-6 justify-center"
    }, Array.from({
      length: bigData.maxCars
    }).map(function (_, index) {
      var car = bigData.cars[index];
      if (car) {
        var _car$title_ar, _car$title_en, _car$title_ar2, _car$title_en2;
        return /*#__PURE__*/React.createElement("div", {
          key: index,
          className: "w-[40%]  md:w-[194px] md:h-[184px] p-3 rounded border border-[#E1E8F2] bg-white border-solid"
        }, /*#__PURE__*/React.createElement("div", {
          className: "relative aspect-[4/3]"
        }, car.is_booked && /*#__PURE__*/React.createElement("div", {
          className: "absolute inset-0 rounded-t opacity-[0.5993] bg-[#6f6e6e] flex items-center justify-center z-30"
        }, /*#__PURE__*/React.createElement("span", {
          className: "absolute ar:right-0 en:left-0 bottom-0 rounded-tr-lg bg-[#4a4d51] w-[74px] h-[24px] flex justify-center items-center text-white text-center text-xs font-bold"
        }, t("محجوزة", {
          ns: "web_search"
        }))), /*#__PURE__*/React.createElement("span", {
          className: stl.removeMeSelected,
          onClick: function onClick() {
            removeCar(parseInt(car.id, 10));
          }
        }), /*#__PURE__*/React.createElement(Link, {
          to: createUrl(car.product_url)
        }, /*#__PURE__*/React.createElement("img", {
          // @ts-ignore
          src: (car === null || car === void 0 ? void 0 : car.image_url) || (car === null || car === void 0 ? void 0 : car.img_url),
          alt: lang === "ar" ? car !== null && car !== void 0 && (_car$title_ar = car.title_ar) !== null && _car$title_ar !== void 0 && _car$title_ar.trim() ? car.title_ar : (car === null || car === void 0 ? void 0 : car.title) || "Car" : car !== null && car !== void 0 && (_car$title_en = car.title_en) !== null && _car$title_en !== void 0 && _car$title_en.trim() ? car.title_en : (car === null || car === void 0 ? void 0 : car.title) || "Car",
          className: "border-solid rounded border border-[#E1E8F2] object-cover w-full h-full max-w-full"
        }))), /*#__PURE__*/React.createElement(Link, {
          to: createUrl(car.product_url),
          className: "text-[#484848] text-center text-xs font-bold leading-5 underline block pt-2 whitespace-nowrap overflow-hidden text-ellipsis hover:underline hover:text-[#484848]"
        }, lang === "ar" ? car !== null && car !== void 0 && (_car$title_ar2 = car.title_ar) !== null && _car$title_ar2 !== void 0 && _car$title_ar2.trim() ? car.title_ar : car === null || car === void 0 ? void 0 : car.title : car !== null && car !== void 0 && (_car$title_en2 = car.title_en) !== null && _car$title_en2 !== void 0 && _car$title_en2.trim() ? car.title_en : car === null || car === void 0 ? void 0 : car.title));
      }
      return /*#__PURE__*/React.createElement("div", {
        key: index,
        className: "w-[40%]  md:w-[194px] md:h-[184px] p-3 rounded border border-[#E1E8F2] bg-white flex items-center justify-center border-solid"
      }, /*#__PURE__*/React.createElement("span", {
        className: "text-[#484848] text-center text-sm font-semibold leading-6"
      }, t("اختر سيارة أخرى", {
        ns: "web_sell_trade"
      })));
    }));
  };
  var renderCompareBar = function renderCompareBar() {
    if (!isCompareBarAllowed()) return null;
    if (!hasCarsToCompare()) return null;
    return /*#__PURE__*/React.createElement(React.Fragment, null, renderSnackBarBar(), /*#__PURE__*/React.createElement("div", {
      className: "mt-4 mb-2 md:!mb-7"
    }, renderCarBox(), /*#__PURE__*/React.createElement(AuthPopupHOC, {
      customModalClassName: "modalHideHeader",
      authScreenDesign: authScreenDesign,
      renderFunc: function renderFunc(checkAuth) {
        return renderStartCompare(checkAuth);
      }
    })));
  };
  var renderAddCar = function renderAddCar(car) {
    var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    // if (!isAddCarAllowed() || !isCarCompareEnabled) return null;
    if (!isAddCarAllowed()) return null;
    return /*#__PURE__*/React.createElement("div", {
      "data-elment": "add-car",
      className: ["flex items-center justify-between border-t border-[#E9E9E9] bg-transparent p-3 cursor-pointer", twMerge(className)].join(" "),
      style: {
        borderTopStyle: "solid"
      },
      onClick: function onClick() {
        isCarIncluded(parseInt(car.id, 10)) ? removeCar(parseInt(car.id, 10)) : addCar(car);
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: [bigData.maxCars == bigData.cars.length && !isCarIncluded(parseInt(car.id, 10)) ? "text-[#C0C0C0]" : "text-[#3C56D4]", "text-xs font-semibold leading-6"].join(" ")
    }, t("قارن هذه السيارة", {
      ns: "web_sell_trade"
    })), /*#__PURE__*/React.createElement("span", {
      className: ["flex items-center justify-center", stl.checkBox, isCarIncluded(parseInt(car.id, 10)) ? stl.checkBoxIncluded : bigData.maxCars == bigData.cars.length ? stl.disableCheckBoxEmpty : stl.checkBoxEmpty].join(" ")
    }));
  };
  var updateData = function updateData(path, value) {
    setBigData(function (prev) {
      var keys = path.split(".");
      var current = prev;
      keys.slice(0, -1).forEach(function (key) {
        if (!current[key]) {
          current[key] = {};
        }
        current = current[key];
      });
      current[keys[keys.length - 1]] = value;
      return _objectSpread({}, prev);
    });
  };
  var updateCarList = function updateCarList(carList) {
    resetAllCars();
    updateData("cars", _toConsumableArray(carList));
  };
  return /*#__PURE__*/React.createElement(CarCompare.Provider, {
    value: {
      canStartComparison: canStartComparison,
      isCarIncluded: isCarIncluded,
      canAddMoreCars: canAddMoreCars,
      addCar: addCar,
      removeCar: removeCar,
      renderAddCar: renderAddCar,
      renderCompareBar: renderCompareBar,
      updateData: updateData,
      bigData: bigData,
      hasCarsToCompare: hasCarsToCompare,
      renderSnackBarBar: renderSnackBarBar,
      renderCarBox: renderCarBox,
      resetAllCars: resetAllCars,
      renderStartCompare: renderStartCompare,
      isCompareBarAllowed: isCompareBarAllowed,
      isAddCarAllowed: isAddCarAllowed,
      updateCarList: updateCarList
    }
  }, children);
};
var useCarCompareContext = function useCarCompareContext() {
  var context = useContext(CarCompare);
  if (!context) {
    throw new Error("useCarCompareContext must be used within a CarCompareProvider");
  }
  return context;
};
export { CarCompareProvider, useCarCompareContext };